import React from 'react'

import Navbar from '../components/Navbar'
import Error from '../components/Error'
import Footer from '../components/Footer'

const ErrorPage = () => {
  return (
    <>
        <Navbar />
        <Error />
        <Footer />
    </>
  )
}

export default ErrorPage